module.exports = __webpack_public_path__ + "static/tpp-image06-93929ec082594ff9a5bb9b6f20476590.jpg";